import { useState, useEffect,useMemo } from "react";
import "./styles.css";
import LoadSimple from "../../LoadSimple";
import { lang } from "../../generales/traduction";
import { capitalizeFirstLetter } from "../../../utils/utils";
import Action from "../../Action";
import InternalError from "../../generales/InternalError";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";    
import {useFetch }from "../../../hooks/useFetch";
import Modal from "react-modal";
import ConfirmAction from "./ConfirAction";
const hostListModalSyncStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "90%",
    padding: "20px",
  },
};
const ModalMain = ({buscar_auths,buscar_folios, users_catalog, buscar_cis,server,dataCis,languaje,mode,handleShowPopup,data,setEditActive,editActive,closCreateCisModal
 }) => {
    const [internalError,setInternalError]=useState(false)
    const [stepSelected, setStepSelected] = useState(1);
    const [disableNext,setDisableNext]=useState(true)
    const [disabledSave,setDisabledSave]=useState(true)
    const [hostSelected,setHostSelected]=useState({hostid:0})
     const [hostsModalOpen, setHostsModalOpen] =useState(false);
     const [loading,setLoading]=useState(false)
     const [error,setError]=useState(null)
     const [registerIsValid,setRegisterIsValid]=useState(false)
    function openHostsModal() {
    //    setCisSelectedAux(elemento);
        setHostsModalOpen(true);
      }
    
      function closHostsModal() {
        
        setHostsModalOpen(false);
      }
     const [cisData,setCisData]=useState({
        ip:(editActive)?dataCis.ip:"",
        hostid:(editActive)?dataCis.hostid:null,
        ci_group_id:(editActive)?dataCis.ci_group_id:null,
        name:(editActive)?dataCis.name:"",
        affiliation:(editActive)?dataCis.affiliation:"",
        description:(editActive)?dataCis.description:"",
        location_id:(editActive)?dataCis.location_id:null,
        service_id:(editActive)?dataCis.service_id:null,
        brand_id:(editActive)?dataCis.brand_id:null,
        model_id:(editActive)?dataCis.model_id:null,
        version:(editActive)?dataCis.version:"",
        serial_no:(editActive)?dataCis.serial_no:"",
        mac:(editActive)?dataCis.mac:"",   
        request_user:(dataCis.request_user)?dataCis.request_user:"",
        auth_user:(dataCis.auth_user)?dataCis.auth_user:"",
        user_comment:(dataCis.user_comment)?dataCis.user_comment:"",
    })
    // const users_catalog=useFetch('cassia/users','','','GET',server)
    const services_catalog=useFetch('cassia/cis_v2/services_catalog','','','GET',server)
    const groups_catalog=useFetch('cassia/cis_v2/groups','','','GET',server)
    const location_catalog=useFetch('zabbix/groups/municipios','','','GET',server)
    const brands_catalog=useFetch('cassia/brands','','','GET',server)
    const [models_catalog,setDataModels]=useState({
        data: [],
        loading: true,
        error: null})
        useEffect(()=>{
            if(cisData.brand_id!=0 && cisData.brand_id!=null) {
              search_marcas(cisData.brand_id)
            }
            
          },[cisData.brand_id])
          const search_marcas = (brand_id) => {
         
            setDataModels({
              data: models_catalog.data,
              loading: true,
              error: null})
            const fetchDataPost = async () => {
              try {
                const response = await fetch(
                  server.url +
                    "/api/v1/cassia/host_models/by_brand/"+brand_id,
                  {
                    method: "GET",
                    headers: {
                      "Content-Type": "application/json",
                      accept: "application/json",
                      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                  }
                );
                if (response.ok) {
                  const data1 = await response.json();
               
                  setDataModels({
                    data: data1,
                    loading: false,
                    error: null})
                } else {
                  const data1 = await response.json();
                  
                  throw new Error("Error en la solicitud");
                }
              } catch (error) {
               
              }
            };
            if(brand_id!=0 && brand_id!=null)   {
              fetchDataPost();
            }
          };
   
const handleChange=(e)=>{
       const {name,value}=e.target
       
        setCisData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value
                }
                
            })
      }

       const changeOption=(option,index)=>{
      
         setCisData((prevState)=>{
                return {
                    ...prevState,
                    [option.filter]:option.label
                }
                
            })
            
    }
    const changeOptionID=(option,index)=>{
      
         setCisData((prevState)=>{
                return {
                    ...prevState,
                    [option.filter]:option.value
                }
                
            })
            
    }
    const Registrar=()=>{
        delete cisData.ip;
        let method='POST'
        let url_add=''
        if(editActive){
            method='PUT'
            url_add=dataCis.id
        }



        setLoading(true)
        const fetchDataPost = async () => {
          
       try {
           // console.log(localStorage.getItem('access_token'))
           const response = await fetch(server.url+'/api/v1/cassia/cis_v2/'+url_add, {
             method: method,  
             headers: {
                 'Content-Type': 'application/json',
                 Authorization: `Bearer ${localStorage.getItem('access_token')}`,
               },
             body: JSON.stringify(cisData),
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoading(false)
             // Manejo de la respuesta
             
             // console.log(data1);
             closCreateCisModal()
           setRegisterIsValid(true)
           handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
           buscar_cis()
           setEditActive(false)
           // buscar_auths()
           // buscar_folios()
            setTimeout(() => {
              setEditActive(false)
               closCreateCisModal()
           setRegisterIsValid(true)
           handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
           buscar_cis()
          

             }, 5000);
         
           } else {
             const data1 = await response.json();
             handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
             
              // setCisData({ip:"",hostid:0,date:"",responsible_name:"",auth_name:"",device_description:"",justification:"",previous_state:"",new_state:"",impact:"",result:"",observations:"",files:[],status:'Activo'})
          setLoading(false)
            // Manejo de errores
            setError(error)
            closCreateCisModal()
            setRegisterIsValid(true)
            
            const timer = setTimeout(() => {
              setRegisterIsValid(false)
              setEditActive(false)
              closCreateCisModal()
            }, 3000);
            console.error(error);
          }
        };

        fetchDataPost();
    }
    function renderAdminComponent() {
   
    try {
        switch (stepSelected) {
            case 1:
                return <Step1 
                        hostSelected={hostSelected}
                        setHostSelected={setHostSelected} 
                        handleChange={handleChange} 
                        changeOption={changeOption} 
                        cisData={cisData}  
                        users_catalog={users_catalog} 
                        languaje={languaje} 
                        editActive={editActive} 
                        setCisData={setCisData} 
                        server={server} 
                        handleShowPopup={handleShowPopup} 
                        mode={mode}/>
                ;
            case 2:
                return <Step2 
                        hostSelected={hostSelected}
                        setHostSelected={setHostSelected} 
                        handleChange={handleChange} 
                        changeOption={changeOptionID} 
                        cisData={cisData} 
                        languaje={languaje} 
                        editActive={editActive} 
                        setCisData={setCisData} 
                        server={server} 
                        handleShowPopup={handleShowPopup} 
                        mode={mode}
                        services_catalog={services_catalog}
                        groups_catalog={groups_catalog}
                        location_catalog={location_catalog}
                        />
                ;
            case 3:
                return <Step3 
                        hostSelected={hostSelected}
                        setHostSelected={setHostSelected} 
                        handleChange={handleChange} 
                        changeOption={changeOptionID} 
                        cisData={cisData} 
                        languaje={languaje} 
                        editActive={editActive} 
                        setCisData={setCisData} 
                        server={server} 
                        handleShowPopup={handleShowPopup} 
                        mode={mode}
                        brands_catalog={brands_catalog}
                        models_catalog={models_catalog}
                        />
                ;
            
                                  default:
                return <></>;
        }
    } catch (error) {
        
        return <div>{lang[languaje['msgErrorPagina']]}</div>;
    }
}
 const hadleChangeList = (e) => {
    setStepSelected(e);
   
  };
  useEffect(()=>{
    if(cisData.name=="" || cisData.affiliation=="" || cisData.request_user=="" || cisData.auth_user=="" || cisData.user_comment.length<5 || (cisData.request_user==cisData.auth_user)){
        setDisabledSave(true)
    }else{
        setDisabledSave(false)
    }

  },[cisData])
    return (
        <>
        <div className="contMainModal">
            <div className="compactMainModal">
                 <div className="titleMainModal">
                <div className="txtTitleMainModal">
                     {((editActive)?lang[languaje]['editar'].toUpperCase():lang[languaje]['crear'].toUpperCase())+' '+lang[languaje]['registroConfiguracion'].toUpperCase()}
                </div>

               
            </div>
            <div className="bodyMainModal">
                <div className={"compactBodyMainModal "}>
       {/* {(internalError)?
            <InternalError/>
            :renderAdminComponent()} */}
       <div className='headBodyMainModal'>
                
                <div className='menuOptionsModal'>
                     <ol className='compactMenuOptionsModal'>
                       
                        <li className={stepSelected===1?'step-selected':''} onClick={() =>hadleChangeList(1)}>{'Inforacion Principal'}</li>
                        <li className={(stepSelected===2?'step-selected':'')+' '+(disabledSave?'disabled-step':'')} onClick={() =>hadleChangeList(2)}>{'Detalles'}</li>

                        <li className={(stepSelected===3?'step-selected':'')+' '+(disabledSave?'disabled-step':'')} onClick={() =>hadleChangeList(3)}>{'Especificaciones'}</li>
                     
                    </ol>
                    <hr className='head-line-monitor'></hr>
                </div>
                
            </div>
            <div className='cont-monitor'>
            {(internalError)?
              <InternalError/>
              :((false)?<LoadSimple/>:renderAdminComponent())

            }
            
                
            </div>
    </div>
            </div>
            <div className="footerMainModal">
                <div className="compactFooterMainModal">
                    <div className="glosario-footer-modal">
                        <ul>
                            <li style={{display:'flex',alignItems:'center'}}>
                               <b style={{color:'red'}}>*</b> <b >&nbsp;</b> &nbsp; {'Campos Requeridos'} 
                            </li>
                           <li style={{display:'flex',alignItems:'center'}}>
                               <b style={{color:'red'}}>{' A '}</b><b >&nbsp;</b> &nbsp; {'Error en el campo'} 
                            </li>
                            <li style={{display:'flex',alignItems:'center'}}>
                               <b style={{fontWeight:'bold'}}>{'( )'}</b><b >&nbsp;</b> &nbsp; {'Caracteristicas Minimas'} 
                            </li>
                        </ul>
                    </div>
                    <div className="actions-footer-modal">

                        <div className="separador-footer-modal">
                            <Action disabled={false} origen={'Cancelar'} titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={()=>closCreateCisModal()} />

                        </div>
                        <div className="separador-footer-modal">
                            <Action disabled={disabledSave} origen={'Cielo'} titulo={(stepSelected<3)?'Siguiente':'Atras'}  action={()=>(stepSelected<3)?setStepSelected(stepSelected+1):setStepSelected(stepSelected-1)} />
                        </div>
                        <div className="separador-footer-modal">
                            <Action disabled={disabledSave} origen={'Azul'} titulo={(capitalizeFirstLetter(lang[languaje]['guardar']))}  action={()=>openHostsModal()} />

                        </div>
                        
                    </div>
                </div>
            </div>
            </div>
        </div> 
        <Modal
        isOpen={hostsModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closHostsModal}
        style={hostListModalSyncStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ConfirmAction 
          groups_catalog={groups_catalog}
          location_catalog={location_catalog}
          services_catalog={services_catalog}
          brands_catalog={brands_catalog}
          models_catalog={models_catalog}
          dataCis={dataCis} loading={loading} error={error} registerIsValid={registerIsValid} closCreateCisModal={closCreateCisModal} editActive={editActive} Registrar={Registrar} server={server}languaje={languaje} cisData={cisData} closHostsModal={closHostsModal}></ConfirmAction>
    </Modal>
        </>       
    )
 }

 export default ModalMain;